import React, { useState } from "react";
import { Link } from "react-router-dom";

const CapitalValeurSection = () => {
  const [currentPerson, setCurrentPerson] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const people = [
    {
      id: 1,
      name: "Philippe Foisy",
      title: "Président et fondateur ",
      title2: " ",
      image: "assets/image/3_Philippe-Foisy.png",
      bio: "Actuaire ayant pratiqué pendant 10 ans dans le domaine de l’assurance de personnes et des produits d’investissement, Philippe a découvert l’immobilier pour la première fois au travers des livres classiques du pionnier québécois Jacques Lépine alors qu’il préparait l’achat de son premier triplex à Longueuil en 2013. Ses premiers contacts avec Nikolai Ray suivis de la naissance du prestigieux Collège MREX ont par la suite donné l’étincelle ultime qui allait tout changer et lancer notre fondateur dans le monde de l’entreprenariat à temps plein, avec comme focus principal l’investissement immobilier mêlé à l’expertise actuarielle traditionnelle – une première en la matière au Québec. Graduellement entre 2013 jusqu’à aujourd’hui, il a bâti avec l’aide de son frère Gabriel et toute l’équipe Beatimo un parc immobilier de plus de 300 logements tout en ayant acquis une forte proportion de terrains dans le centre-ville de St-Hyacinthe. Il rêve de révolutionner la façon de bâtir et maintenir l’écosystème de l’habitation et du logement au Québec et à travers le Canada à l’aide de son expérience en tant qu’Actuaire à créer des systèmes financiers de sécurité sociale (régimes de retraite, assurance vie, produits d’épargne et d’investissement). Ayant grandi partiellement dans une coopérative d’habitation avec son père, ses deux frères et sa sœur, Philippe désire également améliorer et affiner les approches utilisées pour créer et maintenir le parc de logements sociaux et abordables au Québec. Il espère notamment faire partie de la solution en créant la Fondation Béatitude d’ici la fin de 2025 et en y donnant annuellement 10% des profits générés par l’écosystème Beatimo dans le but d’aider les gens à se loger à travers le Québec.",
    },
    {
      id: 2,
      name: "Gabriel Foisy",
      title: "CHEF ",
      title2: "Croissance & Opportunités ",
      image: "assets/image/12_Gabriel-Foisy.png",
      bio: "Fort d’une solide expérience dans plusieurs rôles de vente ainsi que comme courtier en valeurs mobilières suite à son baccalauréat en Finance, Gabriel s’est joint à son frère Philippe à l’automne 2020 pour former ce qui allait devenir la famille Beatimo. Il y a joué depuis ce temps différents rôles dans ce qui allait être pour lui un apprentissage en accéléré des nombreuses différentes facettes de l’investissement immobilier. Il a notamment suivi la majorité des programmes du Collège MREX dès son arrivée dans l’entreprise afin de continuellement se perfectionner tout en étant impliqué de près dans chaque étape de plusieurs projets immobiliers multi-résidentiels alors que notre entreprise continuait sa croissance.  Il a de ce fait même démontré sa capacité à apprendre rapidement, foncer tête baisée vers chaque nouveau défi qui se présente devant lui et devenir le joueur clé dont Beatimo avait tant besoin. Il est aujourd’hui principalement chargé de dénicher les opportunités d’investissement et diriger le développement des affaires aux côtés de notre Président. C’est notamment lui qui a orchestré tous les efforts sur le terrain afin d’acheter près d’une cinquantaine d’immeubles au centre-ville de St-Hyacinthe en seulement 1 an et demi, envoyant un signal fort de la détermination de notre entreprise à être un développeur immobilier innovateur et audacieux. Il joue également un rôle crucial en accompagnant chaque département dans leurs opérations quotidiennes, assurant ainsi une coordination optimale et une synergie efficace.",
      bio2: "Gabriel est la définition même du travail en équipe, toujours prêt à sacrifier pour le bien de tous et être un leader en encouragent l’équipe à foncer sans retenue dans la direction nécessaire pour l’accomplissement de la vision de l’entreprise. Sa passion pour faire progresser l’entreprise est contagieuse et inspirante, en plus de sa dédication à communiquer son expérience pour rendre tout le monde meilleur autour de lui. Toutes ses qualités font de Gabriel un pilier pour l’entreprise, une démonstration constante de nos valeurs et notre passion pour innover et défier le <span>Statu Quo</span> des 30 dernières années en développement immobilier."
    },
    {
      id: 3,
      name: "Etienne Germain",
      title: "CHEF ",
      title2: "Projets ",
      image: "assets/image/8_Etienne-Germain.png",
      bio: "Éclairé par une solide expérience en chantiers de grandes envergures tels que la Salle Symphonique de la Place des Arts ainsi que la transformation de stations de métro montréalaises, Étienne a la responsabilité de la bonne réalisation de tous nos projets majeurs. Il est entre autres l’acteur principal sur le terrain de notre stratégie phare de revitalisation au centre-ville de St-Hyacinthe. Son objectif principal est d'améliorer l'expérience de tous les intervenants entourant un projet, en bâtissant des formules innovantes et efficaces. ",
      bio2: " Étienne est un vrai joueur d’équipe, complètement dédié à la cause et qui se donne sans calculer dans tout projet auquel il contribue. Il est humble, enseignable, courageux, persévérant, passionné et il est affamé dans sa poursuite vers l’excellence. Sa vision et sa capacité à voir au-delà des défis immédiats font de lui un atout précieux pour notre équipe, toujours prêt à repousser les limites pour atteindre de nouveaux sommets."
    },
    {
      id: 4,
      name: "Olivier Baillargeon",
      title: "DIRECTEUR ",
      title2: " Finances et Conformité ",
      image: "assets/image/13_Olivier-Baillargeon.png",
      bio: "Comptable professionnel agréé depuis 2008, Olivier a bâti les fondations de sa carrière professionnelle chez Saputo, où il a fidèlement travaillé pendant 14 ans avant de se joindre à l’équipe de Beatimo à l’été 2024. Toujours en mode <span> apprentissage</span>, il a progressé à travers divers services et rôles, entre autres la comptabilité corporative, l’implantation de logiciels de consolidation, la formation aux comptables des différentes divisions internationales et l’établissement de processus comptables globaux. En parallèle, étant lui-même propriétaire d’immeubles locatifs, il a cultivé au travers des années un vif intérêt pour l'investissement immobilier, ce qui l'a conduit à suivre plusieurs formations au Collège MREX où il a rencontré notre président Philippe Foisy. Cette rencontre fût déterminante pour la suite des choses, devenant l’étincelle qui l’a convaincu de joindre notre famille Beatimo avec un désir ardent de se dépasser et révolutionner avec nous la façon dont les développeurs immobiliers créent de la valeur au Québec.",
      bio2: "Dans sa vie professionnelle comme dans les sports qu’il pratique, il est habile, discipliné et désire toujours aider ses coéquipiers. Il est également un travailleur acharné, persévérant face aux défis les plus ardus et sait rester calme dans les situations plus tendues tout en gardant le focus sur les objectifs les plus importants. Sur un plan plus personnel, Olivier est un jeune et fier grand-père par alliance, qui ajoute au bonheur de sa vie familiale."
    },
    {
      id: 5,
      name: "Samantha Dubé",
      title: "DIRECTRICE",
      title2: "Gestion Immobilière ",
      image: "assets/image/10_Samantha-Dube.png",
      bio: "Animée par une passion profonde pour le potentiel humain au sein des entreprises, Samantha a obtenu en 2020 un certificat en gestion des ressources humaines tout en occupant le poste de Directrice des Opérations et de la Logistique au sein d’une société de sécurité privée en pleine expansion. Son esprit constamment à la recherche de défis l'ont conduite à rejoindre Beatimo Capital en mars 2023, où elle est depuis ce temps en charge du département de Gestion Immobilière et a plus de 400 logements sous sa responsabilité. Forte de plus de dix ans d'expérience en gestion d'équipes et d'opérations, Samantha se distingue par son aptitude avérée pour la résolution de problèmes, son organisation, son souci du détail et son orientation vers les résultats. Travailleuse acharnée, elle est une ressource précieuse pour toute notre équipe, guidée par sa force de caractère hors du commun ainsi que sa conviction inébranlable de l’importance d’avoir une famille unie et forte en toutes circonstances. Elle est pleinement engagée dans son désir de continuer à évoluer et à exceller, tout en contribuant à la réalisation de la vision de Beatimo et en incarnant ses valeurs au quotidien.",
    },
    {
      id: 6,
      name: "Mathieu Magnan",
      title: "GESTIONNAIRE DE PROJETS ",
      image: "assets/image/9_Mathieu-Magnan.png",
      bio: "Avant de découvrir une nouvelle passion pour l’investissement immobilier, Mathieu a voyagé à travers le monde pendant 10 ans avec sa conjointe pour ensuite faire carrière comme arpenteur-géomètre sur différents chantiers majeurs de génie civil. Il a entre autres travaillé sur des projets de parcs d’éoliennes ainsi que sur des chantiers majeurs d’améliorations aux infrastructures publiques de transport en commun.",
      bio2: " Mathieu est un atout très important pour notre équipe en gestion de projets immobiliers par sa versatilité et sa compréhension approfondie des différents aspects entourant l’investissement immobilier multi-résidentiel. Il a notamment étudié au Collège MREX en plus de faire une année complète comme analyste financier dans notre filiale sœur en Services Conseils avant de récemment se joindre à l’équipe de gestion de projets sous la direction d’Étienne Germain. Mathieu se démarque constamment grâce à sa curiosité et son désir d’apprendre et se perfectionner. C’est une personne humble, intègre et au service des autres qui l’entourent. "
    },
    {
      id: 7,
      name: "Isabelle Desrochers",
      title: "CONTRÔLEUSE FINANCIÈRE  ",
      image: "assets/image/7_Isabelle-Desrochers.png",
      bio: "Armée de près de deux décennies d’expérience en comptabilité et tenue de livres à l’emploi d’un chef de file de la distribution de pièce d’autos au Québec, Isabelle est une des premières employées à avoir rejoint l’<span>aventure</span> et le <span>rêve</span> Beatimo en 2019 lorsqu’elle a répondu à l’appel lancé par notre président Philippe Foisy, un ami de longue date. Elle s’assure depuis ce temps de bien gérer au quotidien toutes les opérations de comptabilité de projets variés ainsi que nos différentes filiales à travers la croissance continue de l’entreprise.",
      bio2: "Isabelle est une personne persévérante, fidèle, dédiée, douce et aussi très drôle! Elle est une force tranquille qui va toujours aller jusqu’au bout peu importe les obstacles. En dehors de sa vie professionnelle, Isabelle trouve inspiration et joie dans la danse, une passion qui équilibre son esprit et son corps. Sa riche et longue expérience, en plus de son dévouement exemplaire font d’elle un pilier solide au sein de notre équipe."
    },
    // Your people objects...
  ];

  const openNavValeur = () => {
    setIsSidebarOpen(true);
  };

  const closeNavValeur = () => {
    setIsSidebarOpen(false);
    setCurrentPerson(null);
  };

  const handlePersonClick = (person) => {
    setCurrentPerson(person);
    openNavValeur();
  };

  return (
    <>
      <section className="valeur-section valeur-section-2">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="valeur-content">
                <h5>
                  <img
                    src="assets/image/nos-services-icon.png"
                    alt="Valeur-Section-Img"
                  />{" "}
                  Passionnée
                </h5>
                <h1>
                  Créateurs <br />
                  de <span> valeur</span>
                  {/* <span> immobilière </span> */}
                </h1>
              </div>
            </div>
            <div className="col-lg-6">
              {people.map((person) => (
                <div key={person.id} className="valeur-image">
                  <Link onClick={() => handlePersonClick(person)}>
                    <img
                      src={person.image}
                      className="img-fluid"
                      alt="Valeur-Section-Img"
                    />
                    <div className="valeur-image-content">
                      <div>
                        <h4>{person.name}</h4>
                        <p>{person.title} {person.title2}</p>
                      </div>
                      <img
                        src="assets/image/arrow_right.png"
                        alt="Valeur-Section-Img"
                      />
                    </div>
                  </Link>
                </div>
              ))}
            </div>
            <div className="col-lg-12">
              <div className="Nous-content">
                <h5>
                  <img
                    src="assets/image/nos-services-icon.png"
                    alt="Valeur-Section-Img"
                  />{" "}
                  carrière
                </h5>
                <h1>
                  Nous <span> sommes </span> toujours à <br /> la recherche de{" "}
                  <span> talents.</span> <br /> Êtes-vous{" "}
                  <span> partant ? </span>
                </h1>
                <div className="Nous-button">
                  <Link to="/capital-carrier">
                    <button className="Nous-btn">découvrir nos postes </button>
                    <img
                      className="ps-2"
                      src="assets/image/arrow_right.png"
                      alt="Valeur-Section-Img"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {isSidebarOpen && <div className="overlay" onClick={closeNavValeur}></div>}
      <div id="SidenavValeur" className={`sidenav ${isSidebarOpen ? "open" : ""}`}>
        <Link
          to={{ javascript: void 0 }}
          className="closebtn"
          onClick={() => closeNavValeur()}
        >
          <svg
            width={47}
            height={47}
            viewBox="0 0 47 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x={46}
              y={46}
              width="45.5"
              height="45.5"
              rx="22.75"
              transform="rotate(-180 46 46)"
              fill="white"
            />
            <rect
              x={46}
              y={46}
              width="45.5"
              height="45.5"
              rx="22.75"
              transform="rotate(-180 46 46)"
              stroke="white"
            />
            <path
              d="M19.2807 28.2057L18.2891 27.2141L22.2557 23.2474L18.2891 19.2807L19.2807 18.2891L23.2474 22.2557L27.2141 18.2891L28.2057 19.2807L24.2391 23.2474L28.2057 27.2141L27.2141 28.2057L23.2474 24.2391L19.2807 28.2057Z"
              fill="#ef8551"
            />
          </svg>
        </Link>
        {currentPerson && (
          <div className="foisy-sidebar foisy-sidebar-2">
            <div className="foisy-sidebar-img">
              <img
                src={currentPerson.image}
                className="img-fluid"
                alt="Valeur-Section-Img"
              />
            </div>
            <div className="foisy-sidebar-content">
              <div className="foisy-sidebar-heading">
                <p>{currentPerson.title}</p>
                <h1>{currentPerson.name}</h1>
                <h5>{currentPerson.title2}</h5>
              </div>
              <div className="foisy-sidebar-content-inner">
                <h5>
                <svg width={16} height={14} viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.91451 13.1325H0.55399C0.2539 13.1325 0 12.8902 0 12.5785V1.42901C0 1.12892 0.242358 0.875 0.55399 0.875H9.91451C10.0646 0.875 10.2031 0.932711 10.3069 1.03659L15.8355 6.56517C16.0548 6.78447 16.0548 7.13073 15.8355 7.33848L10.3069 12.9594C10.2031 13.0633 10.0646 13.121 9.91451 13.121V13.1325Z" fill="#EF8551" />
            </svg>
                  BIOGRAPHIE
                </h5>
                <p dangerouslySetInnerHTML={{ __html: currentPerson.bio }}></p>
                <p dangerouslySetInnerHTML={{ __html: currentPerson.bio2 }}></p>
                {/* <h6>{currentPerson.bio}</h6> */}
                {/* <h6>{currentPerson.bio2}</h6> */}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CapitalValeurSection;
